import { __assign, __rest } from "tslib";
import React from 'react';
export var Schema = function (_a) {
    var schema = _a.schema, additionalProps = _a.additionalProps, otherHTMLProperties = __rest(_a, ["schema", "additionalProps"]);
    var content = "<script type=\"application/ld+json\">".concat(JSON.stringify(schema), "</script>");
    return React.createElement("div", __assign({ dangerouslySetInnerHTML: { __html: content } }, additionalProps, otherHTMLProperties));
};
